'use client';

import * as React from 'react';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import * as Styled from './security-button-link.styled';
interface SecurityButtonLinkProps {
  id: string;
  href: string;
  text: string;
}
export const SecurityButtonLink = React.memo(function SecurityButtonLink({
  id,
  href,
  text
}: SecurityButtonLinkProps) {
  return <Styled.ButtonLink href={href} target="_blank" prefetch={false} {...buildQaTrackingEntityProps(`newProfile.info.${id}`)}>
      {text}
    </Styled.ButtonLink>;
});